module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lead-update-business-card"
  }, [(_vm.lead.business_card_image_url) ? _c('div', {
    staticClass: "image_present",
    on: {
      "click": _vm.openBusinessCard
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.lead.business_card_image_url,
      "alt": "business card",
      "onerror": 'this.onerror=null; this.src=\'' + this.image + '\';'
    }
  })]) : _c('div', {
    staticClass: "no_image"
  }, [_c('img', {
    attrs: {
      "src": _vm.image,
      "alt": "no image associated"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-532180b2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/leads/LeadUpdateBusinessCard.vue
// module id = 1908
// module chunks = 0